import React, { useState, useEffect } from "react";
import Form from "react-bootstrap/Form";
import { Row, Col, Button } from "react-bootstrap";
import { useSelector } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrashAlt } from "@fortawesome/free-solid-svg-icons";

const AddNewWebServiceJson = ({ sendDataToParentForJson, error, jsonList, setJsonList }) => {
  const language = useSelector((state) => state.languagesState.languages);

  const handleFieldChange = (e, index) => {
    const { name, value } = e.target;
    const list = [...jsonList];
    list[index][name] = value;
    setJsonList(list);
  };

  useEffect(() => {
    sendDataToParentForJson(jsonList);
  }, [jsonList]);

  const handleFieldRemove = (index) => {
    const list = [...jsonList];
    list.splice(index, 1);
    setJsonList(list);
  };

  const handleFieldAdd = () => {
    setJsonList([...jsonList, { key: "", value: "" }]);
  };
  return (
    <>
      {jsonList.length > 0 &&
        jsonList.map((singleField, index) => (
          <>
            <Form.Label className="formLabel col-xl-3 py-3" htmlFor="url" xl={3}>
            {language?.delete_swal_modal?.field ?? "Field"} {index + 1}
            </Form.Label>
            <Col xl={9}>
              <div key={index} className=" row d-flex justify-content-left align-items-center">
                <div className=" col-5 mt-1">
                  <Form.Control
                    isInvalid={
                      error.index &&
                      Array.isArray(error.index) &&
                      error.index.length > 0 &&
                      error.index.includes(index)
                        ? true
                        : false
                    }
                    name="key"
                    type="text"
                    id="key"
                    value={singleField.key}
                    onChange={(e) => handleFieldChange(e, index)}
                    required
                    placeholder="Enter a key"
                  />
                  <Form.Control.Feedback type="invalid">{error.code}</Form.Control.Feedback>
                </div>
                <div className=" col-5">
                  <Form.Control
                    name="value"
                    type="text"
                    id="value"
                    value={singleField.value}
                    onChange={(e) => handleFieldChange(e, index)}
                    required
                    placeholder="VALUE1,VALUE2"
                  />
                </div>
                <div className=" col-1">
                  {jsonList.length !== 1 && (
                    <div
                      variant="outline-info"
                      style={{ cursor: "pointer" }}
                      onClick={() => handleFieldRemove(index)}
                      className="px-2"
                    >
                      <FontAwesomeIcon icon={faTrashAlt} />
                    </div>
                  )}
                </div>

                {jsonList.length - 1 === index && jsonList.length < 5000 && (
                  <div className="col-12" style={{ textAlign: "center" }}>
                    <Button type="button" onClick={handleFieldAdd} className="btn-sm mt-3 ">
                      <span> +</span>
                    </Button>
                  </div>
                )}
              </div>
            </Col>
          </>
        ))}
    </>
  );
};

export default AddNewWebServiceJson;
